var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-column"},[_c('Swiper'),_vm._v(" "),_c('NewsAgencyRanking'),_vm._v(" "),_c('PlayerRanking'),_vm._v(" "),_c('NewestMatch')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87de2c7a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/event/home/HomeIndex.vue
// module id = null
// module chunks = 